if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      if (this.dcMobileObserver) {
  this.dcMobileObserver.disconnect();
  this.dcMobileObserver = null;
}

this.querySelector('.dc-mobile-buybar')?.remove();
this.classList.remove('dc-mobile-ready');
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const dtLoader = document.createElement('div');
      dtLoader.className = 'dT_loading';
     dtLoader.innerHTML = `<div class="loading"></div>`;
      //document.getElementById('MainContent').appendChild(dtLoader);    
    //  document.querySelector('.main-product_info').appendChild(dtLoader);    
      
      setTimeout( () => {
       	$('.quick-add-modal[open]').find('.main-product_info').addClass('quick-add-modal-in-progress');
        //$('.quick-add-modal[open]').addClass('test');
      }, 2000);//wait 2 seconds
       setTimeout( () => {
         $('.main-product_info').removeClass('quick-add-modal-in-progress');
      }, 4000);//wait 2 seconds
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();        
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();         
          this.preventVariantURLSwitching();
this.setupMobileQuickAdd();
super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');   
         // document.querySelector('.dT_loading').classList.add('hidden');           
          const hideDtLoad = document.querySelectorAll('.dT_loading.hidden');
          document.body.classList.remove('overflow-hidden');
         // hideDtLoad.forEach(div => {
          //  div.remove();
        //  });
        });
    }


    setupMobileQuickAdd() {
  const info = this.modalContent.querySelector('.product__info-container');
  const productForm = info?.querySelector('product-form');
  const originalButton = productForm?.querySelector(
    'button[type="submit"][name="add"]'
  );

  const originalTitle = info?.querySelector('.product__title');
  const originalPrice = info?.querySelector('.price-wrapper');
  const gallery = this.modalContent.querySelector('.product__media-wrapper');
  const dialog = this.querySelector('.quick-add-modal__content');

  // Leave the normal popup intact if required elements are missing.
  if (!info || !originalButton || !originalTitle || !dialog) return;

  this.dcMobileObserver?.disconnect();
  this.querySelector('.dc-mobile-buybar')?.remove();
  this.modalContent.querySelector('.dc-mobile-summary')?.remove();

  const summary = document.createElement('div');
  summary.className = 'dc-mobile-summary';

  const image = document.createElement('img');
  image.className = 'dc-mobile-image';
  image.width = 104;
  image.height = 104;
  image.alt = '';

  const details = document.createElement('div');
  details.className = 'dc-mobile-summary-details';

  const title = document.createElement('h2');
  title.className = 'dc-mobile-title';
  title.textContent = (
    originalTitle.querySelector('h1, h2') || originalTitle
  ).textContent.trim();

  const price = document.createElement('div');
  price.className = 'dc-mobile-price';

  details.append(title, price);
  summary.append(image, details);
  info.prepend(summary);

  // Keep the real variant elements and their existing event handlers.
  const picker = info.querySelector('variant-radios, variant-selects');

  if (picker) {
    let pickerBlock = picker;

    while (pickerBlock.parentElement !== info && pickerBlock.parentElement) {
      pickerBlock = pickerBlock.parentElement;
    }

    if (pickerBlock.parentElement === info) {
      pickerBlock.classList.add('dc-mobile-options');
    }
  }

  const bar = document.createElement('div');
  bar.className = 'dc-mobile-buybar';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'dc-mobile-submit';

  const status = document.createElement('p');
  status.className = 'dc-mobile-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');

  bar.append(button, status);
  dialog.append(bar);

  const sync = () => {
    const unavailable =
      originalButton.disabled ||
      originalButton.getAttribute('aria-disabled') === 'true';

    const loading = originalButton.classList.contains('loading');

    button.disabled = unavailable;
    button.setAttribute('aria-busy', String(loading));

    button.textContent = loading
      ? 'Adding…'
      : (
          originalButton.querySelector('span:not(.hidden)')?.textContent ||
          originalButton.textContent ||
          'Add to Cart'
        ).trim();

    const currentPrice = info.querySelector('.price-wrapper');

    if (currentPrice && price.innerHTML !== currentPrice.innerHTML) {
      const copy = currentPrice.cloneNode(true);

      // Do not duplicate IDs used by the theme's variant updater.
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));

      price.replaceChildren(...copy.childNodes);
    }

    const currentImage =
      gallery?.querySelector('.product__media-item.is-active img') ||
      gallery?.querySelector('.product__media-item img');

    if (currentImage) {
      const src = currentImage.currentSrc || currentImage.src;
      if (image.getAttribute('src') !== src) image.src = src;
      image.hidden = false;
    } else {
      image.hidden = true;
    }

    const errorWrapper = productForm.querySelector(
      '.product-form__error-message-wrapper'
    );

    status.textContent =
      errorWrapper && !errorWrapper.hidden
        ? errorWrapper.querySelector('.product-form__error-message')
            ?.textContent.trim() || ''
        : '';
  };

  button.addEventListener('click', () => {
    // Submit through the existing theme handler, using its selected
    // variant, quantity, loading state and cart-drawer integration.
    if (
      originalButton.disabled ||
      originalButton.getAttribute('aria-disabled') === 'true'
    ) return;

    originalButton.click();
    sync();
  });

  // Observe only original content, not the summary we update.
  this.dcMobileObserver = new MutationObserver(sync);

  [...info.children].forEach(child => {
    if (child !== summary) {
      this.dcMobileObserver.observe(child, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });
    }
  });

  if (gallery) {
    this.dcMobileObserver.observe(gallery, {
      subtree: true,
      childList: true,
      attributes: true
    });
  }

  this.classList.add('dc-mobile-ready');
  sync();
}

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
    const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
     if (!variantPicker) return;      
     variantPicker.setAttribute('data-update-url', 'false');
      
      $('input:radio[name="Color"]').click(function() {      
      $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
      $(this).next('.swatch-element').addClass('clicked');
          });
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();      
       
      const productEnquiry = this.productElement.querySelector('enquiryPopUp');
      if (productEnquiry) productEnquiry.remove();  

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });      
          
    }

    removeGalleryListSemantic() {      
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');      
      if (!galleryList) return;     
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      

      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');        
      if (FBT) FBT.remove();
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
      
    }

  });
}
